import "./App.css";
import AppRouter from "./components/AppRouter";
import { AuthProvider } from "./components/AuthContext/AuthContext";
import AuthProviderElement from "./components/AuthProviderElement";
import { ConfigProvider } from "./config/ConfigProvider";
import PerformanceMonitor from "./components//Tools/PerformanceMonitor";

function App() {
  return (
    <ConfigProvider>
      <AuthProviderElement>
        <AuthProvider>
          <PerformanceMonitor />
          <AppRouter />
        </AuthProvider>
      </AuthProviderElement>
    </ConfigProvider>
  );
}

export default App;
